<template>
  <modal name="restore-data-modal" :height="'200px'" :adaptive="true">
    <div class="restore-data-modal-content">
      <div>
        Please note that all changes made after the selected version will be overridden or given the
        default values.
      </div>
      <div class="restore-data-modal-text">
        Are you sure you want to restore the configuration to this version?
      </div>
      <div class="restore-data-modal-buttons">
        <button @click="cancel" class="btn">Cancel</button>
        <button @click="confirm" class="btn btn-primary">Confirm</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['dataToRestore', 'editorData', 'isAdmin'])
  },
  methods: {
    cancel() {
      this.$store.commit('clearDataToRestore')
      this.close()
    },
    confirm() {
      var values = JSON.parse(this.dataToRestore)
      this.$store.dispatch('updateValues', values).then(() => {
        this.$store.dispatch('showMessage', {
          title: 'Restore Data',
          type: 'success',
          text: 'Data restored successfully'
        })
        this.$store.commit('setDataRestored')
      })
      this.close()
    },
    close() {
      this.$modal.hide('restore-data-modal')
    }
  }
}
</script>

<style scoped>
.restore-data-modal-content {
  padding: 30px;
  text-align: center;
}
@media (max-width: 768px) {
  .restore-data-modal-content {
    padding: 10px;
  }
}
.restore-data-modal-text {
  margin-top: 20px;
}
.restore-data-modal-buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/RestoreDataModal.vue